import React from "react";

// Download icon — a short, bold down arrow pointing into an open tray (˽).
// Inline SVG (not a Unicode glyph) so the arrow can be shorter/bolder than any
// available character and the tray reads clearly. Inherits button text colour.
// Shared by the generate-report buttons and the bulk photo-download button on
// both the admin (ManageSMRTCOP) and crew (SMRTCOP) views, and by the document
// download on SMRT Docs. One definition rather than a copy per module, so
// "the same as the one on SMRT COP" stays true.
export const DownloadIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    style={{ display: "block" }}
  >
    <path d="M12 3.5 V12" />
    <path d="M7.5 9 L12 13.5 L16.5 9" />
    <path d="M6 16.5 V19.5 H18 V16.5" />
  </svg>
);
